<template>
    <navbar position="fixed" :solida="headerSolida" :transparent="transparent" :color="colorMenu" :color-on-scroll="colorOnScroll" menu-classes="ml-auto" style="font-size: 18px;">
      <template v-slot="{toggle, isToggled}">
        <router-link v-popover:popover1 class="navbar-brand" :to="{ name: $store.state.homepage }">
          <img v-bind:src="mensaje('img1')" class="client-logo" alt="" :style="{ height: logo_altura + 'px', width: 'auto' }"/>
          <span v-if="$store.state.editor==true" class="texto-editor-img">menu.json->mensajes:img1</span>
            {{mensaje('tit1')}}<span v-if="$store.state.editor==true" class="texto-editor">[menu.json->mensajes:tit1]</span>
        </router-link>

        <el-popover
              ref="popover1"
              popper-class="popover"
              placement="bottom"
              width="200"
              trigger="hover">
          <div class="popover-body">{{mensaje('tit2')}}<span v-if="$store.state.editor==true" class="texto-editor-img">menu.json->mensajes:tit2</span></div>
        </el-popover>

      </template>
      <template slot="navbar-menu">
        <nav-link ref="foo" v-show="false"></nav-link>
        <div v-for="menu in menus">
          <!--  ELEMENTOS SIN SUBMENU  -->
          <li class="nav-item" v-if="haysubmenu(menu)==false">
              <a class="nav-link" href="#" @click="enlacesimple(menu.enlace)" :style="{ color: colorMenu }"><i :class="menu.icono" :style="{ color: colorMenu }"></i>{{menu.titulo}}</a>
          </li>
          
          <!--  ELEMENTOS CON SUBMENU  -->
          <drop-down tag="li" :title="menu.titulo" :icon="menu.icono" class="nav-item" :color="colorMenu" v-if="haysubmenu(menu)==true">
            <div v-for="submenu in menu.submenu">
              <nav-link v-if="submenu.enlace.name !== 'idioma'" :to="submenu.enlace">
                <i class="now-ui-icons" :class="submenu.icono"></i> {{submenu.titulo}}
              </nav-link>
              <div v-else>
                <!--<div class="nav-link mi-clase" href="#" @click="cambiaIdioma(submenu.titulo)"><i :class="submenu.icono"></i>{{submenu.titulo}}</div>-->
                <div class="nav-link mi-clase" href="#" @click="cambiaIdioma(submenu.titulo)"><img slot="avatar" class="img img-raised" :src="submenu.icono"/><span style="padding-left: 5px;">{{submenu.titulo}}</span></div>
                
              </div>
            </div>
          </drop-down>
        </div>

          <drop-down tag="li" title="Components" icon="now-ui-icons design_app" class="nav-item" :color="colorMenu" v-if="entorno=='development'">
              <nav-link to="/components">
                  <i class="now-ui-icons business_chart-pie-36"></i> Components
              </nav-link>
              <a href="https://demos.creative-tim.com/vue-now-ui-kit-pro/documentation" target="_blank" class="dropdown-item">
                  <i class="now-ui-icons design_bullet-list-67"></i> Documentation
              </a>
          </drop-down>
          <drop-down tag="li" title="sections" icon="now-ui-icons files_paper" class="nav-item" :color="colorMenu" v-if="entorno=='development'">
              <nav-link class="dropdown-item" to="/sections#headers">
                  <i class="now-ui-icons shopping_box"></i> Headers
              </nav-link>
              <nav-link class="dropdown-item" to="/sections#features">
                  <i class="now-ui-icons ui-2_settings-90"></i> Features
              </nav-link>
              <nav-link class="dropdown-item" to="/sections#blogs">
                  <i class="now-ui-icons text_align-left"></i> Blogs
              </nav-link>
              <nav-link class="dropdown-item" to="/sections#teams">
                  <i class="now-ui-icons sport_user-run"></i> Teams
              </nav-link>
              <nav-link class="dropdown-item" to="/sections#projects">
                  <i class="now-ui-icons education_paper"></i> Projects
              </nav-link>
              <nav-link class="dropdown-item" to="/sections#pricing">
                  <i class="now-ui-icons business_money-coins"></i> Pricing
              </nav-link>
              <nav-link class="dropdown-item" to="/sections#testimonials">
                  <i class="now-ui-icons ui-2_chat-round"></i> Testimonials
              </nav-link>
              <nav-link class="dropdown-item" to="/sections#contactus">
                  <i class="now-ui-icons tech_mobile"></i> Contact Us
              </nav-link>
          </drop-down>
          <drop-down tag="li" title="Examples" icon="now-ui-icons design_image" class="nav-item" :color="colorMenu" v-if="entorno=='development'">
              <nav-link to="/about">
                  <i class="now-ui-icons business_bulb-63"></i> About-us
              </nav-link>
              <nav-link to="/blog-post">
                  <i class="now-ui-icons text_align-left"></i> Blog Post
              </nav-link>
              <nav-link class="dropdown-item" to="/blog-posts">
                  <i class="now-ui-icons design_bullet-list-67"></i> Blog Posts
              </nav-link>
              <nav-link class="dropdown-item" to="/contact">
                  <i class="now-ui-icons location_pin"></i> Contact Us
              </nav-link>
              <nav-link class="dropdown-item" to="/landing">
                  <i class="now-ui-icons education_paper"></i> Landing Page
              </nav-link>
              <nav-link class="dropdown-item" to="/login">
                  <i class="now-ui-icons users_circle-08"></i> Login Page
              </nav-link>
              <nav-link class="dropdown-item" to="/pricing">
                  <i class="now-ui-icons business_money-coins"></i> Pricing
              </nav-link>
              <nav-link class="dropdown-item" to="/ecommerce">
                  <i class="now-ui-icons shopping_shop"></i> Ecommerce Page
              </nav-link>
              <nav-link class="dropdown-item" to="/product">
                  <i class="now-ui-icons shopping_bag-16"></i> Product Page
              </nav-link>
              <nav-link class="dropdown-item" to="/profile">
                  <i class="now-ui-icons users_single-02"></i> Profile Page
              </nav-link>
              <nav-link class="dropdown-item" to="/signup">
                  <i class="now-ui-icons tech_mobile"></i> Signup Page
              </nav-link>
          </drop-down>
        
        <span v-if="$store.state.editor==true" class="texto-editor-img">menu.json->menu</span>
        
          
          <!--<li class="nav-item">
              <a class="nav-link btn btn-primary"
                 href="https://www.creative-tim.com/product/vue-now-ui-kit-pro" target="_blank">
                  <p>Buy Now</p>
              </a>
          </li>-->

      </template>
    </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  import {RUTA_BASE} from '@/constants'
  import axios from "axios"
  

  
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    },
    data() {
      return {
        isHovering: false,
        mensajes: [],
        menus: [],
        entorno: '',
        headerSimple: '',
        headerSolida: '',
        colorMenu: '',
        logo_altura: ''
      }
    },
    watch: {
      isToggled: function(val) {
        console.log("istogled: ",val)
      }
      
      
    },
    methods: {
      cambiaIdioma(titulo) {
        this.$store.state.idioma = titulo
        console.log("idioma: ",this.$store.state.idioma)
        var numIdioma = this.$store.state.idiomas[this.$store.state.idioma]
        var cadJson = 'json/menu'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
            this.mensajes = response.data.mensajes
            this.menus = response.data.menu
        })
        .catch(error => console.log(error))
        
        
      },
      

      
      enlacesimple(enlace) {
        //console.log("enlace: ",enlace)
        this.$refs.foo.closeNavbar();
        if (enlace.name == "lnk") {
          window.location.href = enlace.link
        } else {
          this.$router.push(enlace)
        }
        
      },
      mensaje(nom) {
        var mens = ''
        //console.log(this.mensajes)
        this.mensajes.forEach(elemento => {
          if (elemento.nombre==nom) {
            mens = elemento.mensaje
          }
        })
        return(mens)
      },
      haysubmenu(elem) {
        var activo = false
        //console.log('elemento: ',elem)
        if (elem.hasOwnProperty('submenu')) {
          activo = true
        } else {
          activo = false
        }
        return(activo)
      }
    },
    created() {
      
      
      
    },
    mounted() {
      this.entorno = process.env.NODE_ENV
      
      var v_store = this.$store.state
      
      this.headerSimple = v_store.header_simple
      if (this.headerSimple) {
        this.transparent = false
        //this.colorOnScroll = 1
      }
      this.headerSolida = v_store.header_solida
      this.logo_altura = v_store.logo_altura
      this.colorMenu = v_store.menu_color
      console.log("headerSimple: ",this.headerSimple)
      console.log("colorMenu: ",this.colorMenu)
      
      
      var cadJson = 'json/parametros.json'
      axios.get(RUTA_BASE+cadJson)
      .then(response => {
        v_store.idiomas = response.data.idiomas
        v_store.idioma = response.data.idioma
        v_store.editor = response.data.editor
          
        console.log("idioma: ",v_store.idioma)
        var numIdioma = v_store.idiomas[v_store.idioma]
        var cadJson = 'json/menu'+numIdioma.toString()+'.json'
          axios.get(RUTA_BASE+cadJson)
          .then(response2 => {
              console.log(response2)
              this.mensajes = response2.data.mensajes
              this.menus = response2.data.menu
          })
          .catch(error => console.log(error))
          
          
          
      })
      .catch(error => console.log(error))
      
      
      
      
    }    
    
  }
  
  
</script>

<style scoped>


.mi-clase:hover {
  background-color: rgba(219, 219, 219, 0.302) !important; /* Color de fondo cuando se pasa el ratón por encima */
  cursor: pointer;
}


</style>
